class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeDrawerBtn = this.querySelector('.drawer-close-btn')
    this.header = document.querySelector('sticky-header');  
    this.announcementBar = document.querySelector('.announcement-bar__message')
    this.announcementBarBtn = document.querySelector('#announcement-bar-btn')

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.closeDrawerBtn.addEventListener(
      'click',
      this.close.bind(this)
    )

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );


    this.summaryToggle.setAttribute('role', 'button');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'mini-cart'
      },
      {
        id: 'cart-live-region-text'
      }
    ];
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }


  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.getElementById('cart-drawer-details').setAttribute('open', true);
    
    setTimeout(() => {
      document.getElementById('cart-drawer-details').classList.add('menu-opening');      
    }, 100);

    if (this.announcementBar) {
      this.announcementBar.style.zIndex = 0;
    }

    if (this.announcementBarBtn) {
      this.announcementBarBtn.style.display = 'none';
    }

    document.getElementById('transition-body').classList.add('transition-body-fade');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
  }

  close(focusToggle = true) {
    this.detailsContainer.classList.remove('menu-opening');
    this.detailsContainer.classList.add('menu-closing');
    document.getElementById('transition-body').classList.remove('transition-body-fade');

    if (this.announcementBar) {
      this.announcementBar.style.zIndex = 101;
    }

    if (this.announcementBarBtn) {
      this.announcementBarBtn.style.display = 'block';
    }

    setTimeout(() => {
      this.detailsContainer.classList.remove('menu-closing');
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }, 600);
  }

}

customElements.define('cart-drawer', CartDrawer);